import { Component } from "vue-property-decorator";
import dayjs from "dayjs";
import Template from "@/components/BaseCurd/template";
import ViewTab from "./viewtab";
import CurdForm from "@/components/BaseCurd/form";
import {
  ConsoleGatewayServiceProxy,
  ProductRegisterServiceProxy,
} from "@/service-proxies/app-v2/console.service-proxies";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { setLocalStorage } from "@/utils/storage";
import "./index.less";
import { getUserInfo } from '@/utils/auth'
import { RecordRemarkDTO } from "@/service-proxies/app-v2/coproduction.service-proxies";
const service = new ConsoleGatewayServiceProxy();
const productRegisterService = new ProductRegisterServiceProxy();
enum Codes {
  硬件网关 = 1,
  软件网关 = 3,
}

const systemService = new MasterlinkTenantServiceProxy();

@Component({
  CurdForm,
  ViewTab,
})
export default class Devices extends Template {
  name = "devices";
  scroll = false;
  templateModalClass = "device-modal";

  options = {
    retrieve: async function(current, keyWords, size) {
      const tenantId = getUserInfo().tenant_id
      // console.log(this.selectTenant);
      return await service.queryGatewayList(
        current,
        false,
        keyWords,
        size,
        this.selectTenant || tenantId
      );
    },
    create: (data) => {
      const { activateCount, batchNo, name } = data;
      return service.add(activateCount, batchNo, name);
    },
    delete: service.discard.bind(service),
  };
  hidden = ["edit"];
  get lang() {
    return {
      placeholder: this.$t("keyword"),
      search: this.$t("search"),
      create: this.$t("page_devices_management_register"),
      delete: this.$t("page_devices_management_recycle"),
    };
  }
  acl = {
    create: "page_devices_management_register",
    update: "page_devices_management_update",
    delete: "page_devices_management_delete",
    view: "page_devices_management_view",
  };
  showViewDialog = false;
  authorization: any = {};

  get columns() {
    return [
      {
        title: this.$t("page_batch_management_action"),
        // fixed: "left",
        key: "action",
        width: 100,
        customRender: (text, row) => {
          return (
            row.id &&
            <div>
              <a
                type="link"
                disabled={!this.getAcl(this.acl.update)}
                onClick={() => this.openViewDialog(row)}
              >
                {this.$t("page_devices_management_view")}
              </a>
            </div>
          );
        },
      },
      {
        title: this.$t("page_devices_management_sn"),
        dataIndex: "sn",
        key: "sn",
        width: 152,
      },
      {
        title: this.$t("remark"),
        dataIndex: "name",
        key: "name",
        width: 200,
        customRender: (text, row) => {
          return (
            row.id &&
            <div class="editable-cell">
              {row.editable ? (
                <div class="editable-cell-input-wrapper">
                  <a-input
                    value={text}
                    size="small"
                    onChange={(e) => this.handleChange(e, row)}
                    onPressEnter={() => this.check(row)}
                    style={{ marginRight: "8px" }}
                  />
                  <a-icon
                    type="check"
                    class="editable-cell-icon-check"
                    onClick={() => this.check(row)}
                  />
                </div>
              ) : (
                <div class="editable-cell-text-wrapper">
                  <span style="max-width: 160px;overflow: hidden; white-space: nowrap;text-overflow: ellipsis;">
                    {text}
                  </span>
                  <a-icon
                    v-acl={this.acl.update}
                    type="edit"
                    class="editable-cell-icon"
                    onClick={() => this.edit(row)}
                  />
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: this.$t("page_devices_management_satus"),
        dataIndex: "isOnline",
        key: "isOnline",
        width: 106,
        customRender: (isOnline,record) => {
          return record.id &&
          <div>
            <span
              style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                background: "red",
              }}
            ></span>
            <a-badge
              color={isOnline ? "green" : "red"}
              text={isOnline ? this.$t("online") : this.$t("offline")}
            />
          </div>
      },
      },
      {
        // title: this.$t("已用应用数/授权应用数"),
        title: this.$t("page_devices_management_allow_connections"),
        key: "allowConnectionCount",
        width: 100,
        customRender: (row) => {
          // const { usedConnections, allowConnectionCount } = row;
          // return `${usedConnections}/${allowConnectionCount}`;
          return row.allowConnectionCount;
        },
      },
      {
        title: this.$t("page_batch_management_type"),
        dataIndex: "productType",
        key: "productType",
        width: 155,
        customRender: (text) => Codes[text],
      },
      {
        title: this.$t("page_devices_management_version"),
        dataIndex: "version",
        key: "version",
        width: 100,
      },
      {
        title: this.$t("page_devices_management_activate_time"),
        dataIndex: "createTime",
        key: "createTime",
        width: 200,
        customRender: (time) => time ? dayjs(time).format("YYYY-MM-DD HH:mm:ss") : '',
      },
      {
        title: this.$t("page_batch_management_counder"),
        dataIndex: "createUserName",
        key: "createUserName",
        // wdith: 228,
      },
    ];
  }

  get schema() {
    return {
      batchNo: {
        label: this.$t("page_batch_management_register_batch"),
        type: "select",
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_register_batch_tips"),
          },
        ],
        options: async () => {
          const data = await productRegisterService.list("");
          return data.map((r) => ({
            label: r.batchNo,
            value: r.batchNo,
          }));
        },
      },
      activateCount: {
        label: this.$t("page_batch_management_activation_number"),
        type: "inputNumber",
        props: {
          min: 1,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_batch_management_activation_number_tips"),
          },
        ],
      },
      name: {
        label: this.$t("remark"),
        type: "textarea",
        props: {
          maxLength: 255,
        },
      },
    };
  }

  tenants = [];
  selectTenant = null;

  async mounted() {
    const {
      data: { records },
    } = await systemService.getTenants(undefined, 1, -1, undefined, undefined);

    this.tenants = records;
  }

  handleTenantChange() {
    this.getData();
  }

  render() {
    const slot = (
      <div style="display: flex;align-items:center">
         {getUserInfo().tenant_id === '000000' ? 
         (<div style="display: flex;align-items: center">
          <span style="width:40px;font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">{this.$t("page_tenant")}:</span>
          <a-select
            placeholder={this.$t("page_tenant")}
            style="width:250px;margin-right:12px"
            allowClear
            v-model={this.selectTenant}
            onChange={this.handleTenantChange}
          >
            {this.tenants.map((item) => {
              return (
                <a-select-option key={item.id} value={item.tenantId}>
                  {item.tenantName}
                </a-select-option>
              );
            })}
          </a-select>
          </div>): ''
        }
        {/* <span style="width:60px;font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">{this.$t("keyword")}:</span> */}
      </div>
    );

    return (
      <blank-view class="device-wrapper">
        {this.renderHeader(slot)}
        <div style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
        </div>
        <a-modal
          onCancel={() => (this.showViewDialog = false)}
          title={this.$t("page_devices_management_view")}
          visible={this.showViewDialog}
          destroyOnClose={true}
          maskClosable={false}
          footer={() => {
            return (
              <div>
                <a-button onClick={() => (this.showViewDialog = false)}>
                  {this.$t("cancel")}
                </a-button>
                <a-button type="primary" onClick={this.printView}>
                  {this.$t("page_devices_management_print")}
                </a-button>
                <a-button type="primary" onClick={this.downloadView}>
                  {this.$t("page_devices_management_download")}
                </a-button>
              </div>
            );
          }}
        >
          <ViewTab showLeft={true} authorization={this.authorization} />
        </a-modal>
      </blank-view>
    );
  }

  handleChange(e, row) {
    const value = e.target.value;
    row.elitValue = value;
  }
  edit(row) {
    this.$set(row, "editable", true);
    row.elitValue = row.name;
  }
  async check(row) {
    this.$set(row, "editable", false);
    if (row.elitValue == row.name) return;
    await service.update(row.id, row.elitValue);
    this.$message.success(this.$t("page_docdirectory_edit_success"));
    row.name = row.elitValue;
  }

  async openViewDialog(row) {
    const data = await service.exportAuthorization(row.id);
    this.authorization = data;
    this.showViewDialog = true;
  }

  printView() {
    let routeUrl = this.$router.resolve({
      path: "/printDevice",
    });
    setLocalStorage("deviceExport", this.authorization);
    window.open(routeUrl.href, "_blank");
  }
  downloadView() {
    const data = this.authorization.aesFile;
    const name = this.authorization.name;
    const urlObject = window.URL || (window as any);
    const export_blob = new Blob([data]);
    const save_link = document.createElementNS(
      "http://www.w3.org/1999/xhtml",
      "a"
    ) as any;
    save_link.href = urlObject.createObjectURL(export_blob);
    save_link.download = `${this.authorization.sn || "sn"}.txt`;
    const ev = document.createEvent("MouseEvents");
    ev.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    save_link.dispatchEvent(ev);
  }
}
